export const noop = () => void 0;
export const storageStateKey = 'connectedChat';

export const modalBodyStyle = {
	height: '84vh',
	overflowY: 'scroll'
};